// facets-custom.js

openCustomFacetLink = (event, pathname) => {

    event.preventDefault();
    
    const facetLink = new URL(window.location.href);
    
    facetLink.pathname = pathname;

    window.location.href = facetLink.href;
}
